__turbopack_context__.v({
  "content": "TemplateDetailPageHeader-module__4SQPoa__content",
  "slideDown": "TemplateDetailPageHeader-module__4SQPoa__slideDown",
  "stickyHeader": "TemplateDetailPageHeader-module__4SQPoa__stickyHeader",
  "title": "TemplateDetailPageHeader-module__4SQPoa__title",
});
